import React from 'react';
import { ScrollArea } from "@/components/ui/scroll-area";
import { useAppSelector } from '@/hooks/useAppSelector';
import { useParams } from 'react-router-dom';

interface PageTabsProps {
  activePage: string;
  onPageChange: (page: string) => void;
  slug?: string; // Optional - will use from route params if not provided
}

// Helper function to format page labels
const formatPageLabel = (subslug: string | null): string => {
  if (!subslug) return 'Main';
  
  // Convert kebab-case or snake_case to Title Case
  return subslug
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const PageTabs: React.FC<PageTabsProps> = ({ activePage, onPageChange, slug: propSlug }) => {
  // Get slug from props or route params
  const params = useParams<{ slug: string }>();
  const slug = propSlug || params.slug || '';
  
  // Get GraphQL data from Redux
  const graphQLData = useAppSelector((state) => state.graphql.data);
  const pages = graphQLData?.pages || [];
  
  // Log data access
  console.log('[graphQL Redux] PageTabs accessing GraphQL data for:', slug);
  
  // If there's only one page or no pages, don't show tabs
  if (!pages || pages.length <= 1) {
    return null;
  }
  
  return (
    <div className="mb-6">
      <div className="bg-blue-50 rounded-lg p-1.5 border border-blue-100">
        <ScrollArea className="w-full">
          <div className="flex">
            {pages.map((page, index) => (
              <button
                key={index}
                className={`px-4 py-2 font-medium text-sm whitespace-nowrap transition-all duration-200 rounded-md ${
                  (page.subslug || 'main') === activePage 
                    ? 'bg-white text-blue-700 shadow-sm border border-blue-200' 
                    : 'text-blue-600 hover:text-blue-800 hover:bg-white/50'
                }`}
                onClick={() => onPageChange(page.subslug || 'main')}
              >
                {formatPageLabel(page.subslug)}
              </button>
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};

export default PageTabs;
